import {
  MerchantFormValues,
  MERCHANT_VERIFICATION_STATUSES,
  OFFER_VERIFICATION_STATUSES,
  OfferFormValues,
} from 'pages/MerchantPortal/merchant-portal.types';
import * as Yup from 'yup';

export const MERCHANT_PORTAL = 'merchant-portal';
export const MERCHANT_PORTAL_CLASSES = {
  EMPTY_CONTAINER: `${MERCHANT_PORTAL}__empty-container`,
  BODY: `${MERCHANT_PORTAL}__body`,
  MOCK_TOGGLE: `${MERCHANT_PORTAL}__mock-toggle`,
  CONFIRMATION_MODAL: `${MERCHANT_PORTAL}__confirmation-modal`,
};

export const MERCHANT_EMPTY_PAGE_TEXTS = {
  HEADING: 'Get Started with Local Merchants',
  TITLE: 'Currently, there are no local merchants added yet.',
  DESCRIPTION: 'Add a local merchant now to provide your customers with special offers and cashback.',
};

export const MERCHANT_EMPTY_PAGE_BUTTON_LABELS = {
  ADD_MERCHANT: 'Add a local merchant',
};

export const MERCHANT_FORM_INIT_VALS: MerchantFormValues = {
  id: '',
  name: '',
  externalId: '',
  category: null,
  logo: '',
  phone: '',
  address: '',
  city: '',
  country: 'us',
  state: '',
  zip: '',
  contact: {
    name: '',
    phone: '',
    email: '',
  },
  verification: null,
};

export const OFFER_FORM_INIT_VALS: OfferFormValues = {
  id: '',
  merchantName: '',
  title: '',
  description: '',
  additionalNote: '',
  verification: null,
  spendThreshold: '0',
  earnCap: '0',
  // Not available in backend yet
  type: 'Cashback',
  redemptionLimit: 'Multiple Use',
  percentage: '1',
};

export const US_STATES = [
  {
    name: 'Alabama',
    code: 'AL',
  },
  {
    name: 'Alaska',
    code: 'AK',
  },
  {
    name: 'Arizona',
    code: 'AZ',
  },
  {
    name: 'Arkansas',
    code: 'AR',
  },
  {
    name: 'California',
    code: 'CA',
  },
  {
    name: 'Colorado',
    code: 'CO',
  },
  {
    name: 'Connecticut',
    code: 'CT',
  },
  {
    name: 'Delaware',
    code: 'DE',
  },
  {
    name: 'Florida',
    code: 'FL',
  },
  {
    name: 'Georgia',
    code: 'GA',
  },
  {
    name: 'Hawaii',
    code: 'HI',
  },
  {
    name: 'Idaho',
    code: 'ID',
  },
  {
    name: 'Illinois',
    code: 'IL',
  },
  {
    name: 'Indiana',
    code: 'IN',
  },
  {
    name: 'Iowa',
    code: 'IA',
  },
  {
    name: 'Kansas',
    code: 'KS',
  },
  {
    name: 'Kentucky',
    code: 'KY',
  },
  {
    name: 'Louisiana',
    code: 'LA',
  },
  {
    name: 'Maine',
    code: 'ME',
  },
  {
    name: 'Maryland',
    code: 'MD',
  },
  {
    name: 'Massachusetts',
    code: 'MA',
  },
  {
    name: 'Michigan',
    code: 'MI',
  },
  {
    name: 'Minnesota',
    code: 'MN',
  },
  {
    name: 'Mississippi',
    code: 'MS',
  },
  {
    name: 'Missouri',
    code: 'MO',
  },
  {
    name: 'Montana',
    code: 'MT',
  },
  {
    name: 'Nebraska',
    code: 'NE',
  },
  {
    name: 'Nevada',
    code: 'NV',
  },
  {
    name: 'New Hampshire',
    code: 'NH',
  },
  {
    name: 'New Jersey',
    code: 'NJ',
  },
  {
    name: 'New Mexico',
    code: 'NM',
  },
  {
    name: 'New York',
    code: 'NY',
  },
  {
    name: 'North Carolina',
    code: 'NC',
  },
  {
    name: 'North Dakota',
    code: 'ND',
  },
  {
    name: 'Ohio',
    code: 'OH',
  },
  {
    name: 'Oklahoma',
    code: 'OK',
  },
  {
    name: 'Oregon',
    code: 'OR',
  },
  {
    name: 'Pennsylvania',
    code: 'PA',
  },
  {
    name: 'Rhode Island',
    code: 'RI',
  },
  {
    name: 'South Carolina',
    code: 'SC',
  },
  {
    name: 'South Dakota',
    code: 'SD',
  },
  {
    name: 'Tennessee',
    code: 'TN',
  },
  {
    name: 'Texas',
    code: 'TX',
  },
  {
    name: 'Utah',
    code: 'UT',
  },
  {
    name: 'Vermont',
    code: 'VT',
  },
  {
    name: 'Virginia',
    code: 'VA',
  },
  {
    name: 'Washington',
    code: 'WA',
  },
  {
    name: 'West Virginia',
    code: 'WV',
  },
  {
    name: 'Wisconsin',
    code: 'WI',
  },
  {
    name: 'Wyoming',
    code: 'WY',
  },
];

export const MerchantVerificationStatusOptions = [
  { key: MERCHANT_VERIFICATION_STATUSES.PENDING, name: 'Pending Verification' },
  { key: MERCHANT_VERIFICATION_STATUSES.VERIFIED, name: 'Verified' },
  { key: MERCHANT_VERIFICATION_STATUSES.FAILED, name: 'Verification Failed' },
  { key: MERCHANT_VERIFICATION_STATUSES.PENDING_DELETION, name: 'Pending Deletion' },
  { key: MERCHANT_VERIFICATION_STATUSES.DELETED, name: 'Deleted' },
];

export const MerchantOfferVerificationStatusOptions = [
  { key: OFFER_VERIFICATION_STATUSES.PENDING, name: 'Pending Verification' },
  { key: OFFER_VERIFICATION_STATUSES.VERIFIED, name: 'Verified' },
  { key: OFFER_VERIFICATION_STATUSES.FAILED, name: 'Verification Failed' },
];

export const phoneRegex = /^\([0-9]{3}\)\s[0-9]{3}\s-\s[0-9]{4}$/;
export const addressRegex = /^[a-zA-Z0-9\s,.'-]{3,}$/;
export const zipRegex = /^\d{5}(-\d{4})?$/;
// https://emailregex.com/
export const emailRegex =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export const MerchantValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required('Name cannot be empty').max(43, 'Name cannot be longer than 43 characters'),
  id: Yup.string(),
  externalId: Yup.string().trim().required('Merchant ID cannot be empty'),
  category: Yup.string().trim().required('Category cannot be empty').nullable(),
  logo: Yup.mixed().test('is-file-or-string', 'Must be a file or string', (value) => {
    if (typeof value === 'string') return true;
    else if (value instanceof File) return true;
    else if (value === null || value === undefined) return true;
    return false;
  }),
  phone: Yup.string().required('Phone number cannot be empty').matches(phoneRegex, 'Invalid phone number'),
  address: Yup.string().trim().required('Address cannot be empty').matches(addressRegex, 'Invalid address'),
  city: Yup.string().trim().required('City cannot be empty'),
  country: Yup.string().trim().required('Country cannot be empty'),
  state: Yup.string()
    .required('State cannot be empty')
    .oneOf(
      US_STATES.map((s) => s.code),
      'Invalid state',
    ),
  zip: Yup.string().trim().required('Zip code cannot be empty').matches(zipRegex, 'Invalid zip code'),
  contact: Yup.object().shape({
    name: Yup.string().trim(),
    phone: Yup.string().trim().matches(phoneRegex, 'Invalid phone number'),
    email: Yup.string().trim().matches(emailRegex, 'Invalid email address'),
  }),
  verification: Yup.object()
    .shape({
      verificationStatus: Yup.string()
        .oneOf(Object.values(MERCHANT_VERIFICATION_STATUSES))
        .required('Verification status cannot be empty'),
      notes: Yup.string().trim(),
    })
    .nullable()
    .default(null),
});

export const OfferValidationSchema = Yup.object().shape({
  id: Yup.string(),
  merchantName: Yup.string().trim().required('Merchant name cannot be empty'),
  title: Yup.string().trim().required('Offer title cannot be empty'),
  description: Yup.string().trim().required('Offer description cannot be empty'),
  additionalNote: Yup.string(),
  type: Yup.string().trim().required('Offer type cannot be empty'),
  redemptionLimit: Yup.string().required('Select a redemption limit'),
  percentage: Yup.string(),
  spendThreshold: Yup.string().required('Spend threshold cannot be empty'),
  earnCap: Yup.string().required('Earn cap cannot be empty'),
  verification: Yup.object()
    .shape({
      verificationStatus: Yup.string()
        .oneOf(Object.values(OFFER_VERIFICATION_STATUSES))
        .required('Verification status cannot be empty'),
      notes: Yup.string().trim(),
    })
    .nullable()
    .default(null),
});

export const OfferScheduleValidationSchema = Yup.object().shape({
  startDate: Yup.number().required('Start date cannot be empty'),
  endDate: Yup.number()
    .required('End date cannot be empty')
    .test('dates-test', 'End date should be after start date', (value, context) => {
      return value > context.parent.startDate;
    }),
  targetBudget: Yup.string().required('Target budget cannot be empty'),
  budgetNote: Yup.string().trim(),
  budgetConsumed: Yup.string(),
});
